

<form [formGroup]="form">
    <p>Bitte wählen Sie die Mitarbeiter aus, die diesem Termin zugewiesen werden sollen.</p>

    <div class="assign-wrapper">
        <label>Mitarbeiter auswählen (pflicht)</label>
        <assign-employees #assignEmployees [(selectedEmployeeIds)]="selectedEmployeeIds"></assign-employees>
    </div>
    
    <div class="assign-wrapper">
        <label> Dauer (pflicht)</label>
        <afs-input-select [options]="durationOptions" placeholder="Dauer..." [bindOnlyValue]="true" formControlName="selectedDuration" backdropClass="backdrop"></afs-input-select>
    </div>
</form>